import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { PURPLE_GRADIENT, colors, radii } from '@app/components/designTokens';

export const NotFound: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const styles: { [k: string]: React.CSSProperties } = {
    wrap: { padding: 64, textAlign: 'center' },
    code: { fontSize: 64, fontWeight: 800, color: colors.accent, lineHeight: 1 },
    title: { fontSize: 22, fontWeight: 700, color: colors.title, marginTop: 12 },
    body: { color: colors.subtle, fontSize: 15, marginTop: 8, marginBottom: 24 },
    button: {
      padding: '12px 22px',
      fontSize: 14,
      fontWeight: 600,
      color: '#fff',
      background: PURPLE_GRADIENT,
      border: 'none',
      borderRadius: radii.button,
      cursor: 'pointer'
    }
  };
  return (
    <div style={styles.wrap}>
      <div style={styles.code}>404</div>
      <div style={styles.title}>Page not found</div>
      <p style={styles.body}>The page you&apos;re looking for doesn&apos;t exist.</p>
      <button style={styles.button} onClick={() => navigate('/')}>
        Back to Overview
      </button>
    </div>
  );
};
